import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { ExportState } from "./type";
import { generateQueryString } from "../helper/helpers";

export const getExportTemplateField = createAsyncThunk(
  "web/get-export-template-field",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/report-templates/exportable-fields${generateQueryString(
          payload
        )}`
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_TEMPLATE_FIELDS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getAllReportTemplate = createAsyncThunk(
  "web/get-export-templates",
  async (type: string, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/report-templates?report_type=${type}`
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_ALL_TEMPLATES(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getExportById = createAsyncThunk(
  "web/get-single-template",
  async (id: string, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/report-templates/${id}`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_TEMPLATE_ID(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const createExportTemplate = createAsyncThunk(
  "web/create-template",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.post("/admin/report-templates", payload);
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const deleteExportTemplate = createAsyncThunk(
  "web/delete-template",
  async (id: string, thunkAPI) => {
    try {
      const data = await axios.delete(`/admin/report-templates/${id}`);
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const updateExportTemplate = createAsyncThunk(
  "web/update-template",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.put(
        `/admin/report-templates/${payload.id}`,
        payload.body
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const exportReport = createAsyncThunk(
  "web/export-report",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.post(`/admin/report-templates/export`, payload);

      if (data?.status === 204 || data?.data === "") {
        toast.error("No content available for download", {
          position: "top-right",
        });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === 200 && data?.data !== "") {
        const obj = data?.data;
        const url = window.URL.createObjectURL(new Blob([obj]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "export report.csv");
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(url);
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

const initialState: ExportState = {
  loading_fields: false,
  template_fields: {},
  loading_templates: false,
  loading_template_id: false,
  templates: [],
  template_id: {},
  fetching: false,
};

export const exportSlice = createSlice({
  name: "export",
  initialState,
  reducers: {
    SET_TEMPLATE_FIELDS: (state, action) => {
      state.template_fields = action.payload;
    },
    SET_ALL_TEMPLATES: (state, action) => {
      state.templates = action.payload;
    },
    SET_TEMPLATE_ID: (state, action) => {
      state.template_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExportTemplateField.pending, (state) => {
        state.loading_fields = true;
      })
      .addCase(getExportTemplateField.fulfilled, (state) => {
        state.loading_fields = false;
      })
      .addCase(getExportTemplateField.rejected, (state) => {
        state.loading_fields = false;
      })
      .addCase(getAllReportTemplate.pending, (state) => {
        state.loading_templates = true;
      })
      .addCase(getAllReportTemplate.fulfilled, (state) => {
        state.loading_templates = false;
      })
      .addCase(getAllReportTemplate.rejected, (state) => {
        state.loading_templates = false;
      })
      .addCase(getExportById.pending, (state) => {
        state.loading_template_id = true;
      })
      .addCase(getExportById.fulfilled, (state) => {
        state.loading_template_id = false;
      })
      .addCase(getExportById.rejected, (state) => {
        state.loading_template_id = false;
      })
      .addCase(createExportTemplate.pending, (state) => {
        state.fetching = true;
      })
      .addCase(createExportTemplate.fulfilled, (state) => {
        state.fetching = false;
      })
      .addCase(createExportTemplate.rejected, (state) => {
        state.fetching = false;
      })
      .addCase(deleteExportTemplate.pending, (state) => {
        state.fetching = true;
      })
      .addCase(deleteExportTemplate.fulfilled, (state) => {
        state.fetching = false;
      })
      .addCase(deleteExportTemplate.rejected, (state) => {
        state.fetching = false;
      })
      .addCase(updateExportTemplate.pending, (state) => {
        state.fetching = true;
      })
      .addCase(updateExportTemplate.fulfilled, (state) => {
        state.fetching = false;
      })
      .addCase(updateExportTemplate.rejected, (state) => {
        state.fetching = false;
      })
      .addCase(exportReport.pending, (state) => {
        state.fetching = true;
      })
      .addCase(exportReport.fulfilled, (state) => {
        state.fetching = false;
      })
      .addCase(exportReport.rejected, (state) => {
        state.fetching = false;
      });
  },
});

// Action creators are generated for each case reducer function
export const { SET_TEMPLATE_FIELDS, SET_ALL_TEMPLATES, SET_TEMPLATE_ID } =
  exportSlice.actions;

export default exportSlice.reducer;
